import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import * as Loader from 'react-loader-spinner';
import Styles from './index.module.css';

export default function Spinner() {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress && (
      <div className={Styles.container}>
        <Loader.ThreeDots type="ThreeDots" color="#2BAD60" height="100" width="100" />
      </div>
    )
  );
}
